"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XML = void 0;

var _reactIcons = require("react-icons");

var XMLJson = {
  tag: "svg",
  attr: {
    viewBox: "0 0 32 32"
  },
  child: [{
    tag: "path",
    attr: {
      d: "M12.6947 26.9882L11.306 26.6138C11.1282 26.5663 11.0282 26.3923 11.0782 26.2235L18.8942 0.228434C18.9442 0.0596696 19.1275 -0.0352606 19.3053 0.0122045L20.694 0.386651C20.8718 0.434117 20.9718 0.608155 20.9218 0.77692L13.1058 26.7667C13.0558 26.9355 12.8669 27.0357 12.6947 26.9882ZM8.4951 20.38L9.52278 19.2778C9.62833 19.167 9.61167 18.9982 9.49501 18.9033L2.77337 13.4976L9.49501 8.09182C9.61167 7.99689 9.62833 7.82812 9.52278 7.71737L8.4951 6.61513C8.3951 6.50438 8.21734 6.49383 8.10069 6.59403L0.095825 13.3024C-0.0319417 13.4079 -0.0319417 13.5925 0.095825 13.698L8.10069 20.4064C8.21734 20.5013 8.3951 20.4908 8.4951 20.38ZM23.8993 20.4011L31.9042 13.6927C32.0319 13.5872 32.0319 13.4026 31.9042 13.2972L23.8993 6.59403C23.7827 6.4991 23.6105 6.50965 23.5049 6.61513L22.4772 7.71737C22.3717 7.82812 22.3883 7.99689 22.505 8.09182L29.2266 13.4976L22.505 18.9033C22.3883 18.9982 22.3717 19.167 22.4772 19.2778L23.5049 20.38C23.6049 20.4908 23.7827 20.5013 23.8993 20.4011Z"
    },
    child: []
  }]
};

var XML = function XML(props) {
  return (0, _reactIcons.GenIcon)(XMLJson)(props);
};

exports.XML = XML;